import { render, staticRenderFns } from "./subscribeList.vue?vue&type=template&id=0dea229e"
import script from "./subscribeList.vue?vue&type=script&lang=js"
export * from "./subscribeList.vue?vue&type=script&lang=js"
import style0 from "./subscribeList.vue?vue&type=style&index=0&id=0dea229e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports